export default {
    'external-account': "Proveedor",
    'generate-buy-invoice': "Generar Factura de Compra",
    'fill-invoice-data': "Rellenar Datos de la Factura",
    'choose-invoice-entries': "Elegir Artículos de la Factura",
    'order-no': "Número de Pedido",
    'generate-invoice': "Generar Factura",
    'invoice-generated': "Factura de Compra Generada",
    'show-invoice': "Mostrar Factura",
    'create-order': "Crear Pedido",
    "order-updated": "Order data updated successfully",
    "order-delete-alert": "¿Estás seguro de que deseas eliminar el pedido?",
    "order-delete": "Eliminar Pedido",
    "order-date": "Fecha de Pedido",
    "order-status": "Estado del Pedido",
    'not-defined': "No Definido",
    'in-progress': "En Progreso",
    'done': "Hecho"
  };
  